import BunkeyAPI from '../api/BunkeyAPI'
import jwtDecode from 'jwt-decode'
import {
  VALIDATE_INVITE,
  VALIDATE_INVITE_SUCCES,
  VALIDATE_INVITE_FAILURE,
  REGISTER_INVITE,
  REGISTER_INVITE_FAILURE,
  REGISTER_INVITE_SUCCESS,
  REGISTER_INVITE_DONE
} from '../constants/invite-types'
import axios from 'axios'
import { ENDPOINT } from '../utils/index'


export const validateUserInvitation = webToken => {
  return dispatch => {
    dispatch({ type: VALIDATE_INVITE });

    BunkeyAPI({
      url: `invitations/validate`,
      method: 'POST',
      data: {
        'webToken': webToken
      }
    }).then(resp => {
      const decode = jwtDecode(resp.data.accessToken)
      if (decode && decode.user && decode.user._id) {
        dispatch(sendInvitationResponse(decode.user, resp.data.accessToken));

      } else {
        dispatch({
          type: VALIDATE_INVITE_SUCCES,
          payload: {
            user: decode.user,
            accessToken: resp.data.accessToken,
            group: resp.data.group
          }
        })
      }
    }).catch(err => {
      dispatch({
        type: REGISTER_INVITE_FAILURE,
        payload: {
          error: err
        }
      })
    })
  }
}

export const sendInvitationResponse = (user, accessToken, headers) => {
  return dispatch => {

    let instance = axios.create({
      baseURL: `${ENDPOINT}`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    })
    instance.post(`invitations/answer`, {
      'status': 'accepted'
    }).then(resp => {
      dispatch({
        type: REGISTER_INVITE_SUCCESS,
        payload: {
          validate: true,
          user: user,
          headers: headers
        }
      });
    }).catch(err => {
      dispatch({
        type: VALIDATE_INVITE_FAILURE,
        payload: {
          error: err
        }
      });
    })
  }
}

export const setRegisterUser = (user, accessToken) => {
  return dispatch => {
    dispatch({ type: REGISTER_INVITE });

    let instance = axios.create({
      baseURL: `${ENDPOINT}`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    })

    instance.post(`auth/sign-up`, {
      'name': user.name,
      'email': user.email,
      'password': user.password,
      'group': user.group,

    }).then(resp => {
      dispatch(sendInvitationResponse(user, accessToken))
    })
      .catch(err => {
        if (err.message === 'Request failed with status code 409') {
          dispatch(sendInvitationResponse(user, accessToken, err.headers));
        } else {
          dispatch({
            type: REGISTER_INVITE_FAILURE,
            payload: {
              error: err
            }
          });
        }
      })
  }
}

export const isDoneInvitation = () => {
  return dispatch => {
    dispatch({ type: REGISTER_INVITE_DONE })
  }
}